import React, { lazy } from 'react';
type Review = {
  id: number;
  name: string;
  age: number;
  avatar: string;
  text: string;
  stars: number;
  reactions: number;
  timeAgo: string;
};
export function ReviewsSection() {
  const reviews: Review[] = [{
    id: 1,
    name: 'James Kerrigan',
    age: 48,
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    text: "I went from 12 drops a day to almost none. My eyes don't burn at work anymore, and I can finally look at a screen without pain",
    stars: 5,
    reactions: 87,
    timeAgo: '2 hours ago'
  }, {
    id: 2,
    name: 'Emily Mezarin',
    age: 39,
    avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
    text: 'I can wear makeup again without it running down my face by noon. Honestly life-changing.',
    stars: 5,
    reactions: 64,
    timeAgo: '1 hour ago'
  }, {
    id: 3,
    name: 'Clara Dubois',
    age: 52,
    avatar: 'https://randomuser.me/api/portraits/women/67.jpg',
    text: 'It feels like a spa treatment for my eyes. Ten minutes and my vision is clearer the rest of the day',
    stars: 5,
    reactions: 42,
    timeAgo: '45 minutes ago'
  }, {
    id: 4,
    name: 'Benjamin Brown Jr',
    age: 61,
    avatar: 'https://randomuser.me/api/portraits/men/22.jpg',
    text: 'My doctor told me to keep using drops. This actually treated the real cause. Within 2 weeks, the gritty feeling was gone',
    stars: 5,
    reactions: 28,
    timeAgo: '30 minutes ago'
  }, {
    id: 5,
    name: 'Michael Atounde',
    age: 44,
    avatar: 'https://randomuser.me/api/portraits/men/55.jpg',
    text: 'The constant watering is gone. I used to carry drops everywhere — now I sometimes forget I even had dry eye.',
    stars: 5,
    reactions: 13,
    timeAgo: '15 minutes ago'
  }, {
    id: 6,
    name: 'Clara C',
    age: 52,
    avatar: 'https://randomuser.me/api/portraits/women/28.jpg',
    text: "After just one week of using this, I've thrown away all my eye drops. My eyes feel 20 years younger!",
    stars: 5,
    reactions: 3,
    timeAgo: '5 minutes ago'
  }];
  const renderStars = (count: number) => {
    return Array(count).fill(0).map((_, i) => <svg key={i} className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-576">
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-577" />
        </svg>);
  };
  return <section className="py-12" id="reviews-section" data-id="element-578">
      <div className="w-full max-w-2xl mx-auto mb-8 rounded-lg overflow-hidden shadow-md" data-id="element-579">
        <img src="https://cdn.shopify.com/s/files/1/0679/7135/0570/files/gempages_581238827771757064-aaf2ab47-6ede-449c-8e87-59fdc4724b6f.png?v=1756321151" alt="Group of seniors enjoying Oculis 3 eye therapy devices in a relaxing setting" className="w-full h-auto object-cover hover-zoom" width="800" height="500" loading="lazy" decoding="async" onError={e => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = 'https://placehold.co/800x500/e2e8f0/64748b?text=Oculis+3+Device';
      }} data-id="element-580" />
      </div>
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-581">
        Oculis-3 Reviews From Social Media
      </h2>
      <div className="bg-gray-50 rounded-lg p-4 md:p-6 border border-gray-200" data-id="element-582">
        <div className="space-y-4" data-id="element-583">
          {reviews.map(review => <div key={review.id} className="reveal-on-scroll" data-id="element-584">
              <div className="flex items-start space-x-3 bg-white rounded-lg p-4 shadow-sm" data-id="element-585">
                <img src={review.avatar} alt={review.name} className="w-10 h-10 rounded-full object-cover" width="40" height="40" loading="lazy" decoding="async" onError={e => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = `https://ui-avatars.com/api/?name=${review.name.replace(' ', '+')}&background=random`;
            }} data-id="element-586" />
                <div className="flex-1" data-id="element-587">
                  <div className="flex justify-between items-center mb-1" data-id="element-588">
                    <p className="font-medium text-gray-900" data-id="element-589">{review.name}</p>
                    <p className="text-xs text-gray-500" data-id="element-590">{review.timeAgo}</p>
                  </div>
                  <div className="flex mb-2" data-id="element-591">{renderStars(review.stars)}</div>
                  <p className="text-gray-700 mb-2" data-id="element-592">{review.text}</p>
                  <div className="flex items-center space-x-2" data-id="element-593">
                    <button className="flex items-center space-x-1 text-xs text-gray-500 bg-gray-100 hover:bg-gray-200 rounded-full px-3 py-1 transition-colors" data-id="element-594">
                      <span data-id="element-595">❤️</span>
                      <span data-id="element-596">{review.reactions}</span>
                    </button>
                    <button className="text-xs text-gray-500 bg-gray-100 hover:bg-gray-200 rounded-full px-3 py-1 transition-colors" data-id="element-597">
                      Reply
                    </button>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
        <div className="mt-6 flex justify-center" data-id="element-598">
          <div className="bg-white rounded-full shadow-md px-6 py-3 inline-flex items-center space-x-2" data-id="element-599">
            <div className="w-2 h-2 bg-green-500 rounded-full" data-id="element-600"></div>
            <p className="text-sm text-gray-600" data-id="element-601">New reviews coming in...</p>
          </div>
        </div>
      </div>
    </section>;
}